export default {
  BillingTransactionModel: () => import('./BillingTransactionModel'),
};
